import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-admin",
  "use": "icon-admin-usage",
  "viewBox": "0 0 100 100",
  "content": "<symbol viewBox=\"0 0 100 100\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-admin\">\n    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->\n    <title>xhdpi/admin</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-admin_Page-1\" stroke=\"currentColor\" stroke-width=\"1\" fill=\"currentColor\" fill-rule=\"evenodd\">\n        <g id=\"icon-admin_admin\">\n            <circle id=\"icon-admin_Oval\" fill=\"#4A90E2;\" cx=\"50\" cy=\"50\" r=\"50\" />\n            <text id=\"icon-admin_总\" font-family=\"PingFangSC-Regular, PingFang SC\" font-size=\"72\" font-weight=\"normal\" letter-spacing=\"0.0216000006\" fill=\"#F4F4F4\">\n                <tspan x=\"14\" y=\"76\">总</tspan>\n            </text>\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/admin.svg
// module id = BlLF
// module chunks = 107